import { REACT_QUERY_KEYS, bridgeRequest } from 'common'
import { GetReportsHistoryResponse } from 'common/types'
import { TEndpoint, TEntity } from 'contexts/app-context/types'

import { queryOptions } from '@tanstack/react-query'

import { GetAllReportsResponse } from '../../types/YourPersonalData.types'

interface GetReportsHistoryQueryParams {
  endpoint?: TEndpoint
  userCountry?: string
  userSelectedEntity?: TEntity
  isUSBranch: boolean
}

export const getReportsHistoryQueryKey = ({
  userCountry,
  userSelectedEntity,
}: Pick<GetReportsHistoryQueryParams, 'userCountry' | 'userSelectedEntity'>) => [
  REACT_QUERY_KEYS.REPORTS_HISTORY,
  userCountry,
  userSelectedEntity,
]

export const getReportsHistoryQueryOptions = ({
  endpoint,
  userCountry,
  userSelectedEntity,
  isUSBranch,
}: GetReportsHistoryQueryParams) =>
  queryOptions({
    queryKey: getReportsHistoryQueryKey({ userCountry, userSelectedEntity }),
    queryFn: () => {
      if (!endpoint) throw new Error('Report history endpoint is not available')

      return bridgeRequest<GetReportsHistoryResponse | GetAllReportsResponse>({
        endpoint,
        returnAllResponse: false,
        isUSBranch,
      })
    },
    enabled: !!endpoint && !!userCountry && !!userSelectedEntity,
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
  })
